module.exports = __webpack_public_path__ + "static/img/12.0bd8ae3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour5/12.jpg
// module id = 6/Vw
// module chunks = 0